import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

declare let $: any;

@Component({
  selector: "adpp-dropdown-select2",
  template: `<select #eleDropdown data-adpp-lib="select2js" class="form-control">
  <option value="">{{'AUTO_ADS.SELECT_TEXT' | translate}}</option>
  <option *ngFor="let opt of items"
          [value]="opt[keyField]"
          [selected]="model && model === opt[keyField]">
    {{isShowKey ? (opt[keyField] + ' - ') : ''}}{{opt.name || opt.id}}
  </option>
</select>
`,
  styles: [`/deep/ .select2-container--default .select2-selection--single{background-color:#fff;border:1px solid #ddd;border-radius:4px;height:36px;margin-top:8px}/deep/ .select2-container--default .select2-selection--single .select2-selection__rendered{color:#444;line-height:35px}/deep/ .select2-container--default .select2-selection--single .select2-selection__arrow{height:36px;position:absolute;top:8px;right:6px;width:20px}`]
})
export class DropdownSelect2Component implements OnInit, OnChanges {

  @Input() items: any = [];
  @Input() model: any = null;
  @Input() keyField: any = 'code';
  @Input() isShowKey: boolean = false;
  @Output() modelChange = new EventEmitter();

  @ViewChild('eleDropdown') eleDropdown: any = null;

  constructor(public translate: TranslateService) {
    // set translate for js2
    setInterval(() => {
      $('.select2-results__option.select2-results__message').text(this.translate.instant('MESSAGE.NO_RECORD'));
      $('.select2-selection__placeholder').text(this.translate.instant("AUTO_ADS.SELECT_TEXT"));
    }, 1);
  }

  ngOnInit() {
    this.setupLibs();
  }

  ngOnChanges($event: any) {
    if ($event.model && !$event.model.firstChange) {
      this.model = $event.model.currentValue;
      this.setupLibs();
    }
  }


  /**
   * Setup js library for select2js
   */
  setupLibs() {
    //
    setTimeout(() => {
      $(document).ready(() => {
        $(this.eleDropdown.nativeElement).select2({
          placeholder: this.translate.instant("AUTO_ADS.SELECT_TEXT"),
          change: function($event) {
            console.log($event);
          }
        });

        $(this.eleDropdown.nativeElement).on("select2:select", ($event, $name) => {
          const ele = $($event.currentTarget);
          this.model = ele.val();
          this.modelChange.emit(this.model);
        });

      });
    }, 100);

  }
}
